import { render, staticRenderFns } from "./gc-popup-copy-product.vue?vue&type=template&id=5d23661e"
import script from "./gc-popup-copy-product.vue?vue&type=script&lang=js"
export * from "./gc-popup-copy-product.vue?vue&type=script&lang=js"
import style0 from "./gc-popup-copy-product.vue?vue&type=style&index=0&id=5d23661e&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports